var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.524 61C112.524 89.4561 89.4561 112.524 61 112.524C32.5439 112.524 9.47573 89.4561 9.47573 61C9.47573 32.5439 32.5439 9.47573 61 9.47573C89.4561 9.47573 112.524 32.5439 112.524 61ZM61 106.602C86.1853 106.602 106.602 86.1853 106.602 61C106.602 35.8147 86.1853 15.3981 61 15.3981C35.8147 15.3981 15.3981 35.8147 15.3981 61C15.3981 86.1853 35.8147 106.602 61 106.602Z",
    fill: "#FFC107",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 122C94.6894 122 122 94.6894 122 61C122 27.3106 94.6894 0 61 0C27.3106 0 0 27.3106 0 61C0 94.6894 27.3106 122 61 122ZM61 106.602C86.1853 106.602 106.602 86.1853 106.602 61C106.602 35.8147 86.1853 15.3981 61 15.3981C35.8147 15.3981 15.3981 35.8147 15.3981 61C15.3981 86.1853 35.8147 106.602 61 106.602Z",
    fill: "#FFC107",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.602 61C106.602 86.1853 86.1853 106.602 61 106.602C35.8147 106.602 15.3981 86.1853 15.3981 61C15.3981 35.8147 35.8147 15.3981 61 15.3981C86.1853 15.3981 106.602 35.8147 106.602 61Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3 43C63.3 41.3406 62.0487 40 60.5 40C58.9512 40 57.7 41.3406 57.7 43V67C57.7 68.6594 58.9512 70 60.5 70C62.0487 70 63.3 68.6594 63.3 67V43ZM60.5 82C61.4283 82 62.3185 81.6049 62.9749 80.9016C63.6313 80.1984 64 79.2446 64 78.25C64 77.2554 63.6313 76.3016 62.9749 75.5984C62.3185 74.8951 61.4283 74.5 60.5 74.5C59.5717 74.5 58.6815 74.8951 58.0251 75.5984C57.3687 76.3016 57 77.2554 57 78.25C57 79.2446 57.3687 80.1984 58.0251 80.9016C58.6815 81.6049 59.5717 82 60.5 82Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.a39b3572862c2f4b371077d8c1c28e95.svg";
export { ForwardRef as ReactComponent };